<template>
  <div class="screen-box">
    <div class="content-pg">
      <div class="regin-err">
        <div v-if="hasReginedDevices.length > 0">
          <h3>错误信息</h3>
          <!-- <template v-for="(item, index) in hasReginedDevices">
            <div :key="index">{{item}}</div>
          </template> -->
          <a-table class="table" :pagination="pagination" :columns="columns" :dataSource="hasReginedDevices" size="small" @change="pageChange" />
        </div>
      </div>
      <div class="info"  v-if="this.percent !== 100">
        <span>{{info}}</span>
        <a-spin size="large">
          <zx-icon slot="indicator" type="icon-loading1" spin />
        </a-spin>
      </div>
      <a-progress :status="status" type="circle" :percent="percent"></a-progress>
      <div class="result" v-if="status === 'active'">
        <h1 class="tip">正在注册设备请不要刷新或者关闭页面！</h1>
        <h2 class="tip">{{`根据注册设备的数量大小，一般需要您停留在此页面1-5分钟，本次注册设备为${reginTotal}台，大约需要${1}分钟，请耐心等待`}}</h2>
      </div>
      <div class="result" v-if="status === 'success'">
        <h1 class="tip">设备注册成功！</h1>
        <h2 class="tip">{{`共${reginTotal}台设备注册，${hasReginedDevices.length}台失败，${reginTotal - hasReginedDevices.length}台成功`}}</h2>
        <a-button class="success-btn" @click="backTo"><zx-icon type="icon-fanhui1"/>返回</a-button>
      </div>
      <div class="result" v-if="status === 'normal'">
        <h1 class="tip">设备注册结束</h1>
        <h2 class="tip">{{`共${reginTotal}台设备注册，${hasReginedDevices.length}台失败，${reginTotal - hasReginedDevices.length}台成功`}}</h2>
        <a-button class="success-btn" @click="backTo"><zx-icon type="icon-fanhui1"/>返回</a-button>
      </div>
      <div class="result" v-if="status === 'exception'">
        <h1 class="tip">设备注册失败！</h1>
        <h2 class="tip">{{`共${reginTotal}台设备注册，${hasReginedDevices.length}台失败，${reginTotal - hasReginedDevices.length}台成功`}}</h2>
        <a-button class="success-btn" @click="backTo"><zx-icon type="icon-fanhui1"/>返回</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import config from '../../config'
export default {
  data () {
    return {
      // 设备注册进度百分比
      percent: 0,
      // 设备注册的状态
      status: 'active',
      // 设备注册状态的显示信息
      info: '正在检测是否有重复注册的设备,请稍后',
      // 已经注册过的设备
      hasReginedDevices: [],
      reason: '这里服务器会返回失败原因的！',
      pagination:{
        // showSizeChanger: true,
        // pageSizeOptions:['2','10','50','100'],
        pageSize: 4,
        current: 1,
        total : 0,
        showTotal: this.showTotal,
        showQuickJumper:true,
        size: 'small',
      },
      columns: [
        {
          title: 'SN',
          dataIndex: 'sn',
          sorter: (a, b) => parseInt(a.sn) > parseInt(b.sn)
        },
        {
          title: '型号',
          dataIndex: 'oui',
          sorter: (a, b) => a.oui.length - b.oui.length,
        },
        {
          title: '错误类型',
          dataIndex: 'description',
          sorter: (a, b) => a.description.length - b.description.length,
        }
      ],
      limitTime: 5
    }
  },
  props: {
    reginTotal: {
      type: Number
    }
  },
  methods: {
    showTotal () {
      return `共${this.hasReginedDevices.length}条`
    },
    pageChange (page) {
      // console.log(page)
      this.pagination.current = page.current
    },
    // 注册进度条递增，可以考虑通过注册设备的总数来估算递增的速率
    increase (step = 2) {
      if (this.percent < 100) {
        this.status = 'active'
        this.percent += step
      } else if (this.percent >= 100) {
        this.percent = 100
        if (this.hasReginedDevices.length == this.reginTotal) {
          this.status = 'exception'
        } else if (this.hasReginedDevices.length === 0) {
          this.status = 'success'
        } else {
          this.status = 'normal'
        }
        this.getIntervalTimer && clearInterval(this.getIntervalTimer)
      }
    },
    // 轮询向后端发送请求来获取设备注册的状态
    getReginStatus () {
      this.getIntervalTimer = setInterval(() => {
        // todo
        this.$http.get(config.api.get_devices_regin_status).then((res) => {
          console.log(res)
          let {code, result} = res
          if (code === 0 && result.storageFlag === true) {
            if (result.errorList && result.errorList.length != this.hasReginedDevices.length) {
              this.hasReginedDevices = result.errorList
            }
            if (result.percent === 100) {
              this.info = '注册完成'
              this.percent = 100
              this.increase()
            } else {
              this.info = result.message
              let step = this.computedStep(result.percent) || 2
              this.increase(step)
            }
          } else {
            this.getIntervalTimer && clearInterval(this.getIntervalTimer)
          }
        })
      }, 500)
    },
    // 计算增加值的大概范围
    computedStep (percent) {
      // todo
      if (this.percent < percent) {
        let step = percent - this.percent
        return step
      }
    },
    // 返回
    backTo () {
      this.$emit('reginComplete', this.hasReginedDevices)
    },
    listenWindow () {
      // console.log(window.event)
      if (window.event) {
        window.event.returnValue = '请不要关闭该页面'
      }
      return '请不要关闭该页面'
    }
  },
  watch: {
    status (newValue) {
      if (newValue === 'success') {
        this.timeBack = setInterval(() => {
          this.limitTime--
          if (this.limitTime === 0) {
            // this.backTo()
          }
        }, 1000)
      }
    }
  },
  mounted () {
    // this.inc()
    this.getReginStatus()
  },
  // 在页面销毁前清除定时器，以免造成性能浪费
  beforeDestroy () {
    this.intervalTimer && clearInterval(this.intervalTimer)
    this.getIntervalTimer && clearInterval(this.getIntervalTimer)
  }
}
</script>
<style lang="less" scoped>
.screen-box {
  width: 100vw;
  height: 100vh;
  background-color: rgba(250, 250, 250, 0.98);
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  .content-pg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    text-align: center;
    .regin-err {
      color: red;
      width: 100%;
      max-height: 30vh;
      overflow: hidden;
      .table {
        width: 50%;
        margin: 0 auto;
      }
    }
    .info {
      width: 100%;
      font-size: 20px;
      margin: 20px;
    }
    .result {
      width: 100%;
      .tip {
        width: 50%;
        margin: 20px auto;
        // width: 50%;
      }
      .success-btn {
        background-color:#52c41a;
        width: 300px;
        color: #222;
        &:hover {
          border: none;
          color: #111;
        }
      }
    }
    .anticon-spin {
      font-size: 30px;
      color: rgb(32, 25, 32);
    }
  }
}
</style>
